export const FAIR_BILLING_POLICY_URL = 'https://busybusy.com/fair-billing/';
export const PRODUCT_PRICE_URL = 'https://busybusy.com/price/';

export const PRIVACY_POLICY_URL = 'https://alignops.com/privacy';
export const USER_AGREEMENT_URL = 'https://alignops.com/terms';

export const QUICKBOOKS_INTEGRATION_BOOKING_URL =
  'https://calendly.com/busybusy-integration-implementation/qbo-integration-connection-net-new-clone-1';
